import React, { useState } from "react";
import CustomSlider from "../section/CustomSlider";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function UserType() {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);

    const closeModal = () => setIsModalOpen(false);

    return (
        <section className="relative h-[100vh]">
            <div className="container h-full flex justify-between items-center">
                <div className="w-[45%] flex flex-col gap-[40px]">
                    <div>
                        <img className="w-[150px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                    </div>
                    <div className="flex flex-col text-[#09778E] font-bold text-[30px]">
                        <div>{t("Welcome to Academix")}</div>
                        <div>{t("Learning Platform")}</div>
                    </div>
                    <div>
                        <CustomSlider />
                    </div>
                </div>
                <div className="w-[5%]">
                    <img className="h-[650px]" src={require("../../assets/icons/rigister-line.svg").default} alt="" />
                </div>
                <div className="w-[45%] flex flex-col justify-between gap-[50px]">
                    <div className="flex items-center text-center flex-col gap-[8px] justify-center">
                        <div className="flex flex-col text-[#09778E] font-bold text-[30px] capitalize">{t("Please Select user type")}</div>
                        <div className="flex items-center gap-[12px]">
                            <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                            <div className="text-[#5D5A6F] flex items-center gap-[5px]">
                                {t("Do you have an account ?")}<Link to={"/login"} className="text-[#09758b]">{t("Login Now")}</Link>
                            </div>
                            <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                        </div>
                    </div>
                    <div className="flex justify-between relative">
                        <div
                            className="h-[200px] w-[48%] bg-white shadow-[0_0_10px_#00000021] rounded-lg p-5 flex items-center justify-center flex-col gap-4 cursor-pointer relative"
                            onClick={openModal}
                        >
                            <div>
                                <img src={require("../../assets/icons/teacher.svg").default} alt="" />
                            </div>
                            <div className="text-[20px] font-bold text-[#09768d]">{t("Teacher")}</div>
                            <div className="absolute inset-0 bg-black opacity-50 rounded-lg" style={{ pointerEvents: 'none' }}></div>
                        </div>
                        <Link to={"/signup/student"} className="h-[200px] w-[48%] bg-white shadow-[0_0_10px_#00000021] rounded-lg p-5 flex items-center justify-center flex-col gap-4">
                            <div>
                                <img src={require("../../assets/icons/student.svg").default} alt="" />
                            </div>
                            <div className="text-[20px] font-bold text-[#09768d]">{t("Student")}</div>
                        </Link>
                    </div>
                </div>
            </div>

            {/* Modal for "Teacher Not Available" */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-8 rounded-lg shadow-xl max-w-[400px] w-full text-center">
                        <div className="text-[20px] font-bold text-[#09768d] mb-4">
                            {t("Teacher Not Available Now")}
                        </div>
                        <div className="text-[16px] text-[#5D5A6F] mb-6">
                            {t("We are working on it, please check back later.")}
                        </div>
                        <button
                            onClick={closeModal}
                            className="bg-[#09768d] text-white px-6 py-2 rounded-lg hover:bg-[#095f6b] transition duration-200"
                        >
                            {t("Close")}
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
}
